import { MatchOffer } from 'types/MatchOffer';
import styles from './SearchResults.module.css';
import { LiveEvent } from 'types/LiveEvent';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SPORT_NAMES_MAP } from 'config/constants';
import { sportTranslationKey } from 'helpers/sportI18n';
import { SearchResultEvent } from './SearchResultEvent/SearchResultEvent';

interface Props {
  events: Map<number, (MatchOffer | LiveEvent)[]>;
  liveSearch?: boolean;
}

export const SearchResults = ({ events, liveSearch = false }: Props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className={styles.wrapper}>
      {Array.from(events.keys()).map((x) => {
        const sportId = liveSearch
          ? (events.get(x)![0] as LiveEvent).sportId ?? 1
          : (events.get(x)![0] as MatchOffer).league.sport;
        const league = !liveSearch
          ? (events.get(x)![0] as MatchOffer).league
          : null;
        return (
          <div className={liveSearch ? styles.liveResultWrapper : undefined}>
            <div className={styles.leagueHeader} key={x}>
              {liveSearch ? (
                <span>
                  {t(sportTranslationKey(sportId), {
                    defaultValue: SPORT_NAMES_MAP.get(sportId) ?? '',
                  })}
                </span>
              ) : (
                <button
                  type="button"
                  className={styles.leagueLink}
                  onClick={() =>
                    navigate(
                      `/sports-betting/${SPORT_NAMES_MAP.get(sportId)}/${sportId}/${league!.name}/${league!.custom_id}`
                    )
                  }
                >
                  {league!.name}
                </button>
              )}
            </div>
            {events
              .get(x)
              ?.map((event) => (
                <SearchResultEvent event={event} liveEvent={liveSearch} />
              ))}
          </div>
        );
      })}
    </div>
  );
};
